import React from 'react';
import { motion } from 'framer-motion';
import { editorialImage } from '../data/products';
export function Atelier() {
  return <section id="atelier" className="bg-bone" data-id="element-44" data-mp="2er8ojtwiz1tg">
      <div className="mx-auto max-w-[1400px] px-6 py-24 lg:px-12 lg:py-32" data-id="element-45" data-mp="29z7aq3jpl31b">
        <motion.figure initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 1,
        ease: 'easeOut'
      }} className="relative" data-id="element-46" data-mp="29x4cwxcbe5m1">
          <img src={editorialImage} alt="Folded stacks of cocoa, wax paper and teal modal knit garments on a pale oak bench" className="aspect-[4/3] w-full object-cover" loading="lazy" data-id="element-47" data-mp="1vz6besj3e3ny" />
          <figcaption className="mx-auto -mt-10 max-w-2xl bg-bone px-8 pt-10 text-center lg:-mt-16 lg:pt-16" data-id="element-48" data-mp="1m3cs8qavbbx7">
            <blockquote className="font-display text-3xl font-light italic leading-snug text-ink lg:text-4xl" data-id="element-49" data-mp="3lc041is5dzjh">
              “Luxury is the absence of anything that asks for your attention.”
            </blockquote>
            <p className="eyebrow mt-6 text-smoke" data-id="element-50" data-mp="3jqx8sxh9mveg">Tenzy Club — Studio, Tiruppur</p>
          </figcaption>
        </motion.figure>
      </div>
    </section>;
}